import React from "react";

import { Row, Col, Container } from "reactstrap";
import Button from "../Button/Button";
import FooterSubscribe from "./FooterSubscribe";
import styles from "./Footer.module.scss";
import bat from "../../assets/bat.png";
import batMobile from "../../assets/bat.png";
import footerLogo from "../../assets/footerLogo.svg";
import twitter from "../../assets/twitter.svg";
import instagram from "../../assets/instagram.svg";
import linkedin from "../../assets/linkedin.svg";
import facebook from "../../assets/facebook.svg";
import flags from "../../assets/flags.png";
import ACNCBadge from "../../assets/acnc-tick.png";
import MHFABadge from "../../assets/mhfa-badge.png";
import Spacer from "../Spacer/Spacer";

// const donate = window._edo_settings.donate
const donate = window._edo_settings.donate;

const footer = window._edo_settings.footer || {};

const Footer = ({ imageSection = true, formSection = true, navSection = true }) => {
  const firstColumn = footer.slice(0, 6);
  const secondColumn = footer.slice(6, 12);

  return (
    <>
      {imageSection ? (
        <Row style={{ paddingBottom: 0 }} className={`${styles.darkSection} mt-4 pb-md-0`}>
          <Col sm={12} md="5" className="w-100 px-0">
            {/* {window.screen.width > 700 ? (
              <img width="100%" className={styles.sectionImage} src={donate.image?.url} alt="bat" />
            ) : (
              <img width="100%" className={styles.sectionImage} src={donate.image?.url} alt="bat" />
            )} */}
            {window.screen.width > 700 ? (
              <img width="100%" className={styles.sectionImage} src={bat} alt="bat" />
            ) : (
              <img width="100%" className={styles.sectionImage} src={batMobile} alt="bat" />
            )}
          </Col>
          <Col sm={12} md="7" className="pb-2 pb-md-0">
            <Container className="h-100 pl-md-4">
              <Row className="h-100 pl-md-4">
                <Col sm="12" md="10" xl="7" className={`${styles.sectionContent} pl-md-4`}>
                  <h2 className="h2">{donate.title}</h2>
                  <p className="mt-4" style={{ marginBottom: "36px" }}>
                    {donate.description}
                  </p>
                  <a href={donate.link.url}>
                    <Button text={donate.link.title} variant="donation" className="m-auto m-md-0" />
                  </a>
                </Col>
                <Col sm="12" md="5"></Col>
              </Row>
            </Container>
          </Col>
        </Row>
      ) : null}
      {formSection ? <FooterSubscribe /> : null}
      {navSection ? (
        <>
          <Row className={`${styles.darkSection} py-2 pt-5 d-none d-md-flex`}>
            <Container>
              <Row>
                <Col
                  style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}
                  xs="3"
                  className="pt-4"
                >
                  <a href="/">
                    <img
                      className={`${styles.logoImg}`}
                      src={footerLogo}
                      alt="Environmental Defenders Office Logo"
                    />
                    <span className="sr-only">Environmental Defenders Office</span>
                  </a>
                </Col>
                <Col xs="3" className="pt-4">
                  {firstColumn.map((navItem, i) => (
                    <>
                      <h4 className={`${styles.txtLink}`}>
                        <a href={navItem.url} className={styles.sectionLink}>
                          {navItem.title}
                        </a>
                      </h4>
                      {i !== firstColumn.length ? <Spacer size="xs" /> : null}
                    </>
                  ))}
                </Col>
                <Col xs="3" className="pt-4">
                  {secondColumn.map((navItem, i) => (
                    <>
                      <h4 className={`${styles.txtLink}`}>
                        <a href={navItem.url} className={styles.sectionLink}>
                          {navItem.title}
                        </a>
                      </h4>
                      {i !== secondColumn.length ? <Spacer size="xs" /> : null}
                    </>
                  ))}
                </Col>
                <Col xs="3" className="pt-4">
                  <a
                    href="https://www.facebook.com/EnvironmentalDefendersOffice/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={facebook} className="mr-2" alt="facebook icon" />
                    <span className="sr-only">Facebook</span>
                  </a>
                  <a href="https://twitter.com/EDOLawyers" target="_blank" rel="noreferrer">
                    <img src={twitter} className="mr-2" alt="twitter icon" />
                    <span className="sr-only">Twitter</span>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/environmentaldefendersoffice"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={linkedin} className="mr-2" alt="linkedin icon" />
                    <span className="sr-only">LinkedIn</span>
                  </a>
                  <a
                    href="https://www.instagram.com/environmentaldefendersoffice/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={instagram} className="mr-2" alt="instagram icon" />
                    <span className="sr-only">Instagram</span>
                  </a>
                  <p className={`${styles.contactTxt}`}>
                    <small>
                      <i>
                        Authorised by David Morris, Environmental Defenders Office Ltd, Suite 8.02 Level 8, 6 O'Connell St, Sydney NSW 2000 • ABN: 72 002 880 864
                      </i>
                    </small>
                  </p>
                  <p className={`${styles.contactTxt} pt-0`}>
                    <small>
                      <strong>Postal Address:</strong>
                      <br/>
                      <span>PO Box R1105 Royal Exchange NSW 1225</span>
                    </small>
                  </p>
                  <div className="d-flex">
                    <div style={{ marginTop: "24px" }} className="mr-2">
                      <img
                        className={`${styles.logoImg}`}
                        src={ACNCBadge}
                        alt="ACNC Registered Charity Badge"
                        style={{ height: "auto" }} 
                      />
                      <span className="sr-only">ACNC Registered Charity Badge</span>
                    </div>
                    <div style={{ marginTop: "24px" }}>
                      <img
                        className={`${styles.logoImg}`}
                        src={MHFABadge}
                        alt="Mental Health First Aid Badge"
                        style={{ height: "auto" }} 
                      />
                      <span className="sr-only">Mental Health First Aid Badge</span>
                    </div>
                  </div>
                </Col>
                <Col xs="12">
                  <hr className={styles.horizontalDivisor} />
                </Col>
                <Col xs="2" className="pt-3 mb-4">
                  <img src={flags} className="mr-2" alt="flags" />
                </Col>
                <Col xs="10" className={`${styles.colInfo} pt-2 mb-4`}>
                  <small>
                    EDO recognises the traditional owners and custodians of the land, seas and rivers of
                    Australia. We pay our respects to Aboriginal and Torres Strait Islander elders past and
                    present, and aspire to learn from traditional knowledge and customs so that, together, we
                    can protect our environment and cultural heritage through law.
                  </small>
                </Col>
              </Row>
            </Container>
          </Row>
          <Row className={`${styles.darkSection} py-2 px-1 d-md-none`}>
            <Spacer size="s" />
            <Col xs="6" className="pt-4 text-center col-12">
              <a href="/">
                <img src={footerLogo} alt="Environmental Defenders Office Logo" />
                <span className="sr-only">Environmental Defenders Office</span>
              </a>
            </Col>
            <Spacer size="s" />
            <Col xs="3" className="pt-4 col-6">
              {firstColumn.map((navItem, i) => (
                <>
                  <h4 className={`${styles.txtLink}`}>
                    <a href={navItem.url} className={styles.sectionLink}>
                      {navItem.title}
                    </a>
                  </h4>
                  {i !== firstColumn.length ? <Spacer size="xs" /> : null}
                </>
              ))}
            </Col>
            <Col xs="3" className="pt-4 col-6">
              {secondColumn.map((navItem, i) => (
                <>
                  <h4 className={`${styles.txtLink}`}>
                    <a href={navItem.url} className={styles.sectionLink}>
                      {navItem.title}
                    </a>
                  </h4>
                  {i !== secondColumn.length ? <Spacer size="xs" /> : null}
                </>
              ))}
            </Col>
            <Spacer size="l" />
            <Col xs="12" className="pt-3">
              <a
                href="https://www.facebook.com/EnvironmentalDefendersOffice/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={facebook} className="mr-2" alt="facebook icon" />
              </a>
              <a href="https://twitter.com/EDOLawyers" target="_blank" rel="noreferrer">
                <img src={twitter} className="mr-2" alt="twitter icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/environmentaldefendersoffice"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedin} className="mr-2" alt="linkedin icon" />
              </a>
              <a
                href="https://www.instagram.com/environmentaldefendersoffice/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagram} className="mr-2" alt="instagram icon" />
              </a>
            </Col>
            <Col className="pt-2">
              <p>
                <small>
                  <i>
                    Authorised by David Morris, EDO Environmental Defenders Office Ltd , Suite 8.02 Level 8, 6 O'Connell St, Sydney NSW 2000 • ABN: 72 002 880 864
                  </i>
                </small>
              </p>
              <p>
                <small>
                  <strong>Postal Address:</strong>
                  <br/>
                  <span>PO Box R1105 Royal Exchange NSW 1225</span>
                </small>
              </p>
            </Col>
            <Spacer size="l" />
            <hr
              style={{
                width: "100%",
                borderTop: "1px solid #F7F5F0",
                opacity: 0.2,
                margin: 0,
              }}
            />
            <Spacer size="s" />
            <Col xs="12" className="pt-3">
              <img src={flags} className="mr-2" alt="flags" />
            </Col>
            <Col className="text-center pt-2">
              <small>
                EDO recognises the traditional owners and custodians of the land, seas and rivers of
                Australia. We pay our respects to Aboriginal and Torres Strait Islander elders past and
                present, and aspire to learn from traditional knowledge and customs so that, together, we can
                protect our environment and cultural heritage through law.
              </small>
              <Spacer size="s" />
            </Col>
          </Row>
        </>
      ) : null}
    </>
  );
};

export default Footer;
